
import Vue from "vue";
export default Vue.extend({
  name: "Contact",
  data() {
    return {
      links: [
        { label: "Email", value: "fabio@stitchdev.pt", href: "mailto:fabio@stitchdev.pt", icon: "envelope-o", color: "#3d8be8" },
        { label: "GitHub", value: "github.com/DannyIsYog", href: "https://github.com/DannyIsYog", icon: "github", color: "#e2e8f0" },
        { label: "LinkedIn", value: "linkedin.com/in/fabio-sousa", href: "https://www.linkedin.com/in/f%C3%A1bio-sousa-8aa655196/", icon: "linkedin", color: "#0a66c2" },
        { label: "Itch.io", value: "dannyisyog.itch.io", href: "https://dannyisyog.itch.io/", icon: "gamepad", color: "#fa5c5c" },
        { label: "Twitter", value: "twitter.com/DannyIsYog", href: "https://twitter.com/DannyIsYog", icon: "twitter", color: "#1d9bf0" },
      ]
    };
  }
});
